module.exports = __webpack_public_path__ + "static/media/SMTF.22733cc3.pdf";